// Used to extend and add a new allFunds constant field to source data to drive our hierarchical/pivot grid
export const ALLFUNDS = { allFunds: 'All funds' };
export type AllFunds = typeof ALLFUNDS;
export type AllFundsDataRow<T extends object> = T & AllFunds;
